import React from 'react';

function DisplayAndDeleteRoleContent({ role, roles, setRoles, rolesForAssignment, rolesForAssignmentDisplay, setRolesForAssignmentDisplay }) {

    const handleDeleteRole = () => {

        if (rolesForAssignment.some(r => r.name === role.name)) {
            const updatedRoles = roles.filter(r => r.name !== role.name);
            setRoles(updatedRoles);
            setRolesForAssignmentDisplay([...rolesForAssignmentDisplay, role]);
        }
    }

    return (
        <li className="flex justify-between items-center px-4 py-3 border-b border-gray-200 dark:border-slate-700 last:border-b-0">
            <span className="text-gray-900 dark:text-white">{role.label}</span>
            <div>
                <button
                    type="button"
                    className="px-3 py-1 text-sm border border-red-600 text-red-600 rounded-lg hover:bg-red-50 transition-colors"
                    onClick={handleDeleteRole}
                >
                    Delete
                </button>
            </div>
        </li>
    )
}

export default DisplayAndDeleteRoleContent
